/*
  BUTTOM 15/10/2026: "Calculá tu envío" por provincia.
  - Con productos en el carrito, pide a Shopify las tarifas reales (las de Configuración > Envíos),
    así que si cambian los precios del envío en Shopify, esto se actualiza solo.
  - Con el carrito vacío (ficha del producto antes de agregar), usa la TABLA_RESPALDO de abajo.
    Si cambian las tarifas en Shopify, actualizar también esta tabla.
*/
(function () {
  if (window.customElements.get('buttom-calcula-envio')) return;

  var ENVIO_GRATIS_DESDE = 8000000; // $80.000 en centavos (antes de descuentos, igual que la app Hoppy)

  // Código postal de la capital de cada provincia: Shopify lo pide, pero el precio depende sólo de la provincia.
  var CP = {
    'Ciudad Autónoma de Buenos Aires': 'C1414', 'Buenos Aires': '1900', 'Catamarca': '4700', 'Chaco': '3500',
    'Chubut': '9100', 'Córdoba': '5000', 'Corrientes': '3400', 'Entre Ríos': '3100', 'Formosa': '3600',
    'Jujuy': '4600', 'La Pampa': '6300', 'La Rioja': '5300', 'Mendoza': '5500', 'Misiones': '3300',
    'Neuquén': '8300', 'Río Negro': '8500', 'Salta': '4400', 'San Juan': '5400', 'San Luis': '5700',
    'Santa Cruz': '9400', 'Santa Fe': '3000', 'Santiago del Estero': '4200', 'Tierra del Fuego': '9410',
    'Tucumán': '4000'
  };

  // Tarifas de Shopify al 15/10/2026. Sólo se usan con el carrito vacío.
  var TABLA_RESPALDO = {
    caba: [
      { n: 'A domicilio', p: 5400, t: 'llega en 24 h' },
      { n: 'Retiro en sucursal de Correo Argentino', p: 5549, t: '' }
    ],
    ba: [
      { n: 'A domicilio', p: 8200, t: 'llega en 24 h' },
      { n: 'Retiro en sucursal de Correo Argentino', p: 5549, t: '' }
    ],
    interior: [
      { n: 'A domicilio', p: 8600, t: 'llega en 3 a 5 días' },
      { n: 'Retiro en sucursal de Correo Argentino', p: 6549, t: 'llega en 3 a 5 días' }
    ]
  };

  var CLAVE = 'buttom_provincia';

  function zona(prov) {
    if (prov === 'Ciudad Autónoma de Buenos Aires') return 'caba';
    if (prov === 'Buenos Aires') return 'ba';
    return 'interior';
  }

  function etiqueta(nombre) {
    if (/sample/i.test(nombre)) return 'Envío del Sample Kit';
    if (/sucursal/i.test(nombre)) return 'Retiro en sucursal de Correo Argentino';
    return 'A domicilio';
  }

  function plazo(tarifa, prov) {
    var d = tarifa.delivery_days;
    if (d && d.length === 2) {
      if (d[0] === 1 && d[1] === 1) return 'llega en 24 h';
      return d[0] === d[1] ? 'llega en ' + d[0] + ' días' : 'llega en ' + d[0] + ' a ' + d[1] + ' días';
    }
    if (zona(prov) === 'interior') return 'llega en 3 a 5 días';
    if (/sucursal/i.test(tarifa.name)) return '';
    return 'llega en 24 h';
  }

  function plata(n) {
    return '$' + Math.round(n).toLocaleString('es-AR');
  }

  function leer() {
    try { return window.localStorage.getItem(CLAVE) || ''; } catch (e) { return ''; }
  }

  function guardar(v) {
    try { window.localStorage.setItem(CLAVE, v); } catch (e) {}
  }

  class ButtomCalculaEnvio extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._alCambiar = function (e) {
        if (e.target && e.target.matches && e.target.matches('select')) {
          guardar(e.target.value);
          self.calcular();
          document.dispatchEvent(new CustomEvent('buttom:provincia', { detail: { origen: self, valor: e.target.value } }));
        }
      };
      this._alCambiarOtro = function (e) {
        if (e.detail && e.detail.origen === self) return;
        var select = self.querySelector('select');
        if (select) select.value = (e.detail && e.detail.valor) || leer();
        self.calcular();
      };
      this._alActualizarCarrito = function () {
        setTimeout(function () { self.calcular(); }, 300);
      };
      this.addEventListener('change', this._alCambiar);
      document.addEventListener('cart:update', this._alActualizarCarrito);
      document.addEventListener('buttom:provincia', this._alCambiarOtro);
      this.calcular();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._alCambiar);
      document.removeEventListener('cart:update', this._alActualizarCarrito);
      document.removeEventListener('buttom:provincia', this._alCambiarOtro);
    }

    async calcular() {
      var select = this.querySelector('select');
      var salida = this.querySelector('.buttom-ce__resultado');
      if (!select || !salida) return;
      if (!select.value && leer()) select.value = leer();
      var prov = select.value;
      if (!prov) { salida.innerHTML = ''; return; }
      var pedido = (this._pedido || 0) + 1;
      this._pedido = pedido;
      salida.textContent = 'Calculando…';

      var filas = null;
      var gratis = false;
      try {
        var carrito = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        var bruto = 0;
        (carrito.items || []).forEach(function (i) { bruto += i.original_line_price; });
        gratis = bruto >= ENVIO_GRATIS_DESDE;
        if (carrito.item_count > 0) {
          var q = new URLSearchParams({
            'shipping_address[country]': 'Argentina',
            'shipping_address[province]': prov,
            'shipping_address[zip]': CP[prov] || ''
          });
          var r = await fetch('/cart/shipping_rates.json?' + q.toString());
          if (r.ok) {
            var j = await r.json();
            if (j.shipping_rates && j.shipping_rates.length) {
              filas = j.shipping_rates.map(function (x) {
                return { n: etiqueta(x.name), p: parseFloat(x.price), t: plazo(x, prov) };
              });
            }
          }
        }
      } catch (e) {}
      if (pedido !== this._pedido) return;
      if (!filas) filas = TABLA_RESPALDO[zona(prov)];
      filas.sort(function (a, b) { return a.p - b.p; });

      var html = filas.map(function (f) {
        var precio = gratis || f.p === 0 ? 'Gratis' : plata(f.p);
        return '<div class="buttom-ce__fila"><span>' + f.n + (f.t ? ' · ' + f.t : '') + '</span><strong>' + precio + '</strong></div>';
      }).join('');
      html += gratis
        ? '<p class="buttom-ce__nota">Tu compra supera $80.000: el envío es gratis.</p>'
        : '<p class="buttom-ce__nota">Gratis en compras desde $80.000.</p>';
      salida.innerHTML = html;
    }
  }

  window.customElements.define('buttom-calcula-envio', ButtomCalculaEnvio);
})();
